import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {MembershipsPage, OrdersHistoryPage, PaymentHistoryPage, StarterpacksPage, NotFoundPage,SubmissionCrmErrorsPage} from '../../pages';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/orders-history" component={OrdersHistoryPage} />
    <Route path="/memberships" component={MembershipsPage} />
    <Route path="/starterpacks" component={StarterpacksPage} />
    <Route path="/payment-history" component={PaymentHistoryPage} />
    <Route path="/submission-crm-errors" component={SubmissionCrmErrorsPage} />
    <Route path="/404" component={NotFoundPage} />
    <Redirect from="*" to="/404" />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes/Routes.tsx